import { Component, OnInit, Input, Output  } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-primary-button',
  templateUrl: './primary-button.component.html',
  styleUrls: ['../button.component.scss'],
})
export class PrimaryButtonComponent implements OnInit {
  @Input() normalBtn:boolean = false;
  @Input() btnText: string;
  @Input() customClassAppBtn: string; //recibe: class
  @Input() isDisabled:boolean = false;
  @Input() type: string = 'button'; //submit | button | reset

  @Input() addIcon: string | null = null; //left | right
  @Input() iconClass: string = '';

  @Output() btnClick: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {}

  //clases del normalBtn: el padding por defecto solo se aplica si el caller no trae el suyo
  get btnClasses(): string {
    const custom = (this.customClassAppBtn ?? '').trim();
    return this.tienePadding(custom) ? custom : `py-2.5 px-4 ${custom}`.trim();
  }

  //detecta p- px- py- pt- pb- pl- pr-, ignorando variantes (lg:, hover:, etc.)
  private tienePadding(clases: string): boolean {
    return clases.split(/\s+/).some(clase => /^p[xytblr]?-/.test(clase.slice(clase.lastIndexOf(':') + 1)));
  }

  onClickBtn(event:Event) {
    this.btnClick.emit(event);
  }

}

